<template>
  <div class="review-card">
    <div class="review-card-header">
      <GFMP :styles="{ ...fmpStyles.rounded, height: '72px', width: '72px' }" />
      <div class="review-product-info">
        <GFMP v-for="i in 3" :key="i" :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(30) }" />
      </div>
      <div class="review-product-rating">
        <GFMP v-for="i in 2" :key="i" :styles="{ ...fmpStyles.circle, height: '16px', minWidth: '16px' }" />
      </div>
    </div>
    <div class="review-card-body">
      <div class="review-summary">
        <div class="review-summary-rating">
          <GFMP v-for="i in 5" :key="i" :styles="fmpStyles.circle" />
        </div>
        <GFMP :styles="{ ...fmpStyles.rounded, width: '48px' }" />
      </div>
      <div class="review-text">
        <GFMP v-for="i in 4" :key="i" :styles="{ ...fmpStyles.rounded, width: getRandomPercentage(50) }" />
      </div>
      <div class="review-gallery">
        <GFMP
          v-for="i in 5"
          :key="i"
          :wrapper-styles="{ flexGrow: 1 }"
          :styles="{ ...fmpStyles.rounded, height: undefined, width: '100%', aspectRatio: '1/1' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-card-loader',
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
          minWidth: '12px',
        },
      },
    };
  },
  methods: {
    getRandomPercentage(min = 30, max = 100) {
      return `${min + Math.random() * (max - min)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

@mixin flexColumn {
  display: flex;
  flex-direction: column;
}

@mixin flexSpaceBetween {
  display: flex;
  justify-content: space-between;
}

@mixin rating {
  display: flex;
  gap: 4px;
}

.review {
  &-card {
    @include flexColumn();
    width: 100%;

    &-header {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 16px;
      background-color: #fff;

      .review {
        &-product {
          &-info {
            @include flexColumn();
            gap: 12px;
            flex-grow: 1;
          }
          &-rating {
            @include rating();
          }
        }
      }
    }

    &-body {
      @include flexColumn();
      gap: 16px;
      padding: 16px;
      background-color: #f6f6f6;

      .review {
        &-summary {
          @include flexSpaceBetween();

          &-rating {
            @include rating();
          }
        }

        &-text {
          @include flexColumn();
          @include rating();
        }

        &-gallery {
          @include flexSpaceBetween();
          gap: 8px;
        }
      }
    }
  }
}
</style>
